import { map } from 'lodash'

export const menuSettingsDataWithoutKeyUuid = (menuSettings) =>
  map(
    menuSettings,
    (
      {
        provideTipSuggestions,
        visible,
        visibilityName,
        serviceTypeName,
        leadingOrderNumberText,
      },
      index
    ) => {
      if (
        !!(serviceTypeName === 'Kiosk' || serviceTypeName === 'POS')
      ) {
        return {
          [index]: {
            provideTipSuggestions,
            leadingOrderNumberText,
            [visibilityName]: visible,
          },
        }
      } else {
        return {
          [index]: {
            provideTipSuggestions,
            leadingOrderNumberText,
            [visibilityName]: visible,
          },
        }
      }
    }
  )
